import { Observation } from "@medplum/fhirtypes";

import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

const postpartumObservationsAdapter = createEntityAdapter({
  selectId: (observation: Observation) => observation.id ?? "",
});

const reducers = {
  loadPostpartumObservations: postpartumObservationsAdapter.setAll,
  addPostpartumObservation: postpartumObservationsAdapter.addOne,
  updatePostpartumObservation: postpartumObservationsAdapter.updateOne,
  removePostpartumObservation: postpartumObservationsAdapter.removeOne,
  clearPostpartumObservations: postpartumObservationsAdapter.removeAll,
};

export const postpartumObservationsSlice = createSlice({
  name: "postpartumObservations",
  initialState: postpartumObservationsAdapter.getInitialState(),
  reducers,
});

export const {
  loadPostpartumObservations,
  addPostpartumObservation,
  updatePostpartumObservation,
  removePostpartumObservation,
  clearPostpartumObservations,
} = postpartumObservationsSlice.actions;

// Selectors
export const selectPostpartumObservations = (state: RootState) =>
  state.postpartumObservations.entities;
export const selectPostpartumObservationById = (state: RootState, id: string) =>
  state.postpartumObservations.entities[id];

export default postpartumObservationsSlice.reducer;
